// components/ui/Underline.tsx
"use client";

import { c as _c } from "react/compiler-runtime";
import { m, useInView, useReducedMotion } from "framer-motion";
import { useRef } from "react";
export type UnderlineProps = {
  className?: string;
  pathD?: string;
  strokeWidth?: number;
  delay?: number;
  /** Gdy true, animacja startuje przy wejściu w viewport (pod sekcjach z whileInView) */
  useWhileInView?: boolean;
};
const PATH_VARIANTS = {
  hidden: {
    pathLength: 0,
    opacity: 0
  },
  visible: {
    pathLength: 1,
    opacity: 1
  }
} as const;
export default function Underline(t0) {
  const $ = _c(13);
  const {
    className: t1,
    pathD: t2,
    strokeWidth: t3,
    delay: t4,
    useWhileInView: t5
  } = t0;
  const className = t1 === undefined ? "h-5 w-[150px] md:h-6 md:w-[180px]" : t1;
  const pathD = t2 === undefined ? "M2 20 C 48 10, 96 10, 140 16 S 180 26, 196 18" : t2;
  const strokeWidth = t3 === undefined ? 4 : t3;
  const delay = t4 === undefined ? 0.8 : t4;
  const useWhileInView = t5 === undefined ? false : t5;
  const reduce = useReducedMotion();
  const ref = useRef(null);
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      once: true,
      amount: 0.2
    };
    $[0] = t6;
  } else {
    t6 = $[0];
  }
  const isInView = useInView(ref, t6);
  const t7 = reduce ? undefined : "hidden";
  const t8 = reduce ? undefined : useWhileInView ? isInView ? "visible" : "hidden" : "visible";
  let t9;
  if ($[1] !== delay || $[2] !== reduce) {
    t9 = reduce ? {
      duration: 0
    } : {
      duration: 0.9,
      delay,
      ease: "easeOut"
    };
    $[1] = delay;
    $[2] = reduce;
    $[3] = t9;
  } else {
    t9 = $[3];
  }
  let t10;
  if ($[4] !== pathD || $[5] !== strokeWidth || $[6] !== t9) {
    t10 = <m.path d={pathD} stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke" pathLength={1} variants={PATH_VARIANTS} transition={t9} />;
    $[4] = pathD;
    $[5] = strokeWidth;
    $[6] = t9;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  let t11;
  if ($[8] !== className || $[9] !== t10 || $[10] !== t7 || $[11] !== t8) {
    t11 = <m.svg ref={ref} aria-hidden={true} viewBox="0 0 260 34" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" initial={t7} animate={t8}>{t10}</m.svg>;
    $[8] = className;
    $[9] = t10;
    $[10] = t7;
    $[11] = t8;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  return t11;
}